module.exports = __webpack_public_path__ + "public/files/img/arab-avatar.614d9258.png";